export default __webpack_public_path__ + "static/PAPC-824-86dd3692f0895808dcc3d1fc8cff1f7b.jpg";